/**
 * TikTok icon — minimal, accessibility-safe SVG.
 * Lucide-react doesn't include a TikTok glyph by default, so we ship our own.
 * Uses currentColor so it inherits text color (matches the .text-white/50
 * convention of the surrounding social link styling).
 */
export default function TikTokIcon({ className = '', strokeWidth = 0 }) {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      aria-hidden="true"
    >
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.3a8.16 8.16 0 0 0 4.77 1.5v-3.43a4.85 4.85 0 0 1-1.84-.68z" />
    </svg>
  );
}
